import React from "react";
import { useNavigate } from "react-router-dom";
import NoticePage from "../components/NoticePage";

function UnAuthorised() {
    const navigate = useNavigate();
    return (
        <NoticePage icon="lock" tone="bad" title="Access denied">
            <p className="cf-muted">You don’t have permission to view this page.</p>
            <div className="cf-cta-row is-centered">
                <button className="cf-btn cf-btn-ghost" onClick={() => window.history.go(-3)}>Go back</button>
                <button className="cf-btn cf-btn-primary" onClick={() => navigate('/')}>Go home</button>
            </div>
            <p className="cf-muted mt-5">If you believe this is a mistake, please contact support.</p>
        </NoticePage>
    );
}

export default UnAuthorised;
